<div class="">
    <div class="card">
        <!-- Card header -->
        <div class="card-header border-0">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">Marksheet</h3>
            </div>
          
          </div>
        </div>

        <div class="container">
                 <!-- Light table -->
        <div class="table-responsive " >
            

            <table #dataTable  class="table align-items-center table-flush">
             
            </table>
            <div class="m-4">

            </div>
  
          </div>
        </div>
       
      </div>
    </div>
    